import { cn } from '@/utlis/cn'
import { cardXPad } from '../UserCard'

type AudioInputContainerProps = {
    children?: React.ReactNode
}
export function DeviceContainer(props: AudioInputContainerProps) {
    return (
        <div className="border-b-1 border-white/3 last:border-b-0 pb-2 last:pb-0 pt-2 first:pt-0">
            <div className={cn('flex flex-col gap-[14px]', cardXPad)}>{props.children}</div>
        </div>
    )
}
